import React from "react";

// The collection logo, for a token whose metadata is unreachable. It shows no token number, unlike the card art.
const FALLBACK_IMAGE = "/validator/logo.jpg";

// maalCoins is a uint256 string in whole MAAL; same separators as the metadata ("15,094,950").
const formatMaal = (value) => String(value || 0).replace(/\B(?=(\d{3})+(?!\d))/g, ",");

/**
 * Most token images are the card alone, 520x754 with transparent corners, so
 * they fill a frame of that shape. A few (#17) are a 1000x1000 export with the
 * card centred on #1b1b1b; the same colour behind them makes that margin blend in.
 */
const ART_FRAME = { aspectRatio: "520 / 754", background: "#1b1b1b" };

// That square export draws the card at 48% x 72% of the image: doubling it fills the frame, which clips the margin.
const zoomSquareExport = (event) => {
  const img = event.currentTarget;
  if (img.naturalWidth === img.naturalHeight) img.style.transform = "scale(2)";
};

const shortWallet =(wallet) => (wallet ? `${wallet.slice(0, 6)}...${wallet.slice(-4)}` : "");

/**
 * Cards for validator NFTs from fetchValidatorNfts or fetchAllValidatorNfts. They
 * have no `_id` and are not traded here, so they link nowhere. `nfts` undefined
 * means still loading; `showOwner` adds each holder, for lists of many wallets.
 */
function ValidatorNftCards({ nfts, showOwner = false, emptyText = "No validator NFTs yet", wrapperClassName = "" }) {
  if (!nfts) return <p className="p-y-7 t-a-c">Loading...</p>;
  if (nfts.length === 0) return <p className="p-y-7 t-a-c">{emptyText}</p>;

  return nfts.map((nft) => {
    const locked = nft.lockedTill > Date.now();
    return (
      <div className={wrapperClassName} key={`${nft.NFTContract}-${nft.tokenID}`}>
        <div className="b-1 b-r-5 o-h">
          <div className="d-f a-i-c j-c-c o-h" style={ART_FRAME}>
            <img
              src={nft.imageURL || FALLBACK_IMAGE}
              alt={`${nft.symbol} #${nft.tokenID}`}
              className="w-100 h-100"
              // The art is a card with the tier and holdings printed on it: show all of it.
              style={{ objectFit: "contain" }}
              onLoad={nft.imageURL ? zoomSquareExport : undefined}
            />
          </div>
          <hr className="ma-0" />
          <div className="f-w-600 para_clr pa-1">
            <div>
              {nft.symbol} #{nft.tokenID}
            </div>
            <div className="f-s-0_8">
              Tier {nft.tier} &middot; {formatMaal(nft.maalCoins)} MAAL
            </div>
            {showOwner && nft.Owner?.[0] ? (
              <div className="f-s-0_8" title={nft.Owner[0]}>
                Owner {shortWallet(nft.Owner[0])}
              </div>
            ) : (
              ""
            )}
            {locked ? (
              <div className="f-s-0_8">
                Locked until {new Date(nft.lockedTill).toLocaleDateString()}
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    );
  });
}

export default ValidatorNftCards;
